/**
 * Check if a thread title is a default/auto-generated title
 * @param {string} title - The thread title to check
 * @returns {boolean} True if the title is a default title
 */
export function isDefaultTitle(title) {
  if (!title) return true;
  return !!(
    title === "New Chat" ||
    title === "Untitled Chat" ||
    title.startsWith("Chat ") ||
    title.match(/^Chat [a-f0-9]{6}\.\.\.$/i)
  );
}

/**
 * Check if a workspace is the Personal Project
 * A workspace is considered the Personal Project if it has both:
 * - name === "Personal Project"
 * - is_personal === true
 * @param {Object} workspace - The workspace object to check
 * @returns {boolean} True if the workspace is the Personal Project
 */
export function isPersonalProject(workspace) {
  if (!workspace) return false;
  return (
    workspace.name === "Personal Project" && workspace.is_personal === true
  );
}
